export const ADS_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'title', label: 'عنوان', align: 'left' },
  { id: 'status', label: 'وضعیت', align: 'left' },
  { id: 'start_date', label: 'تاریخ شروع', align: 'left' },
  { id: 'end_date', label: 'تاریخ پایان', align: 'center' },
  { id: 'start_time', label: 'زمان شروع', align: 'left' },
  { id: 'end_time', label: 'زمان پایان', align: 'center' },
  { id: 'order1', label: 'سفارش کل', align: 'left' },
  { id: 'order2', label: 'سفارش پخش شده', align: 'left' },
  { id: '' },
];

export const APP_SECTION_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationSectionLable', label: 'عنوان', align: 'center', stickyCell: true },
  { id: 'ApplicationSectionID', label: 'کد یکتا', align: 'center' },
  { id: 'ApplicationSectionBackgroundImage', label: 'تصویر پس زمینه (تم روشن)', align: 'center' },
  { id: 'ApplicationSectionBackgroundImageDark', label: 'تصویر پس زمینه (تم تیره)', align: 'center' },
  { id: 'ApplicationSectionBackgroundColor', label: 'رنگ پس زمینه (تم روشن)', align: 'center' },
  { id: 'ApplicationSectionBackgroundColorDark', label: 'رنگ پس زمینه (تم تیره)', align: 'center' },
  { id: 'ApplicationSectionBackgroundRepeat', label: 'وضعیت تکرار پس زمینه', align: 'center' },
  { id: 'ApplicationSectionStatus', label: 'وضعیت نمایش', align: 'center' },
  { id: '' },
];

export const APP_SECTION_LIST_MODAL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationSectionLable', label: 'عنوان', align: 'center' },
  { id: 'ApplicationSectionKeyOrder', label: 'کد یکتا', align: 'center' },
  { id: '' },
];

export const PROFILE_REWARD_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ProfileApplicationRewardTransactionAmountTypeID', label: 'نوع پاداش', align: 'center' },
  { id: 'ProfileApplicationRewardAmount', label: 'هزینه پاداش', align: 'center' },
  { id: '' },
];

export const EXCHANGE_CONFIG_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'TransactionExchangeConfigLabel', label: 'عنوان ترازو', align: 'center', stickyCell: true },
  { id: 'TransactionExchangeConfigRate', label: 'تعداد', align: 'center' },
  // todo
  { id: 'source', label: 'ارز  مبدا', align: 'center' },
  { id: 'destination', label: 'ارز  مقصد', align: 'center' },
  { id: 'TransactionExchangeConfigID', label: 'شناسه', align: 'center' },
  { id: '' },
];

export const CONTENT_HUB_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  // { id: 'media_id', label: 'کد ثبت', align: 'center' },
  { id: 'MediaTitle', label: 'عنوان', align: 'left', stickyCell: true },
  { id: 'mediaStatuses', label: 'وضعیت محتوا', align: 'center' },
  { id: 'MediaTypeLable', label: 'نوع محتوا', align: 'center' },
  // { id: 'media_imdb', label: 'کد یکتا', align: 'center' },
  { id: 'MediaYear', label: 'سال تولید', align: 'center' },
  // { id: 'MediaDateCreate', label: 'تاریخ ثبت', align: 'center' },
  { id: 'MediaProvide', label: 'فرمت مدیا', align: 'center' },
  { id: '' },
];

export const CONTENT_HUB_MODAL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'MediaTitle', label: 'عنوان', align: 'center' },
  { id: 'MediaTypeLable', label: 'نوع محتوا', align: 'center' },
  { id: 'MediaYear', label: 'سال تولید', align: 'center' },
  { id: 'MediaIMDB', label: 'کد ثبت', align: 'center' },
  { id: 'MediaDateCreate', label: 'تاریخ ثبت', align: 'center' },
  { id: '' },
];

export const DUEL_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'DuelTitle', label: 'عنوان', align: 'left', stickyCell: true },
  { id: 'GameName', label: 'نام بازی', align: 'left' },
  { id: 'DuelCreateTime', label: 'تاریخ شروع', align: 'left' },
  { id: 'DuelExpireTime', label: 'تاریخ انقضا', align: 'left' },
  { id: 'DuelOrderBy', label: 'ترتیب', align: 'center' },
  // { id: 'DuelMinimumScore', label: 'حداقل امتیاز ورود', align: 'center' },
  { id: 'TransactionAmountTypeLable', label: 'واحد پرداخت', align: 'center' },
  { id: 'DuelAmount', label: 'هزینه', align: 'center' },
  { id: 'DuelJoinNeedPayment', label: 'شامل پرداخت', align: 'center' },
  { id: 'DuelJoinNeedPayment', label: 'وضعیت تورنومنت', align: 'center' },
  { id: '' },
];

export const DUEL_LEADERBOARD_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'avatar', label: 'آواتار', align: 'center' },
  { id: 'ProfileName', label: 'نام', align: 'center' },
  { id: 'ProfileLastname', label: 'نام خانوادگی', align: 'center' },
  { id: 'Mobile', label: 'شماره موبایل', align: 'center' },
  { id: 'Ranked', label: 'رتبه', align: 'center' },
  { id: 'score', label: 'امتیاز', align: 'center' },
];

export const GAME_FEE_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameName', label: 'عنوان', stickyCell: true },
  { id: 'GameEntryFeeIsActive', label: 'رایگان ', align: 'center' },
  // { id: 'TransactionAmountTypeLable', label: 'نوع واحد پرداخت', align: 'center' },
  { id: 'GameEntryFeeAmount', label: 'هزینه قابل پرداخت', align: 'center' },
  { id: 'GameEntryFeeDurationTime', label: 'دستاورد هزینه پرداخت شده', align: 'center' },
  // { id: 'GameEntryFeeID', label: 'شناسه', align: 'center' },
  { id: '' },
];

export const GAME_JOIN_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameName', label: 'عنوان', stickyCell: true },
  // { id: 'GameJoinApplicationGameID', label: 'شناسه بازی', align: 'center' },
  { id: 'GameJoinApplicationHasLeaderBoard', label: 'شامل رتبه بندی', align: 'center', tooltip: 'لیدربرد' },
  { id: 'GameJoinApplicationHasScoreBoard', label: 'شامل امتیاز بندی', align: 'center', tooltip: 'اسکوربورد' },
  { id: 'GameJoinApplicationIsFree', label: 'هزینه دارد', align: 'center' },
  { id: 'TransactionAmountTypeLable', label: 'واحد هزینه', align: 'center' },
  { id: 'GameJoinApplicationAmount', label: 'مقدار هزینه', align: 'center' },
  // { id: 'GameJoinApplicationCallBackLable', label: 'کال بک', align: 'center' },
  { id: '' },
];

// FOOTBALOP ------------------------------------------------------------

export const GAME_CARD_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'FootbalopGameCardImages', label: 'تصویر', align: 'center' },
  { id: 'FootbalopGameCardName', label: 'نام بازیکن', align: 'center', stickyCell: true },
  { id: 'FootbalopGameCardNation', label: 'ملیت', align: 'center' },
  { id: 'FootbalopGameCardTeam', label: 'تیم', align: 'center' },
  { id: 'FootbalopGameCardSeason', label: 'فصل', align: 'center' },
  { id: 'FootbalopGameCardPostion', label: 'پست', align: 'center' },
  { id: 'FootbalopGameCardAttak', label: 'حمله', align: 'center' },
  { id: 'FootbalopGameCardDefence', label: 'دفاع', align: 'center' },
  { id: 'FootbalopGameCardSpeed', label: 'سرعت', align: 'center' },
  { id: 'FootbalopGameCardOverall', label: 'امتیاز کلی', align: 'center' },
  { id: 'FootbalopGameCardPrice', label: 'قیمت', align: 'center' },
  { id: 'FootbalopGameCardStartKit', label: 'کیت شروع', align: 'center' },
  { id: 'FootbalopGameCardNumber', label: 'شماره کارت', align: 'center' },
  { id: 'FootbalopGameCardVersion', label: 'نسخه کارت', align: 'center' },
  { id: 'FootbalopGameCardID', label: 'شناسه کارت', align: 'center' },
  { id: '' },
];

export const GAME_CARD_LIST_MODAL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'FootbalopGameCardImages', label: 'تصویر', align: 'center' },
  { id: 'FootbalopGameCardName', label: 'نام بازیکن', align: 'center' },
  { id: 'FootbalopGameCardNation', label: 'ملیت', align: 'center' },
  { id: 'FootbalopGameCardTeam', label: 'تیم', align: 'center' },
  { id: '' },
];

export const GAME_PLANET_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'FootbalopPlanetTitle', label: 'عنوان', align: 'center' },
  { id: 'FootbalopPlanetImageHome', label: 'تصویر خانه', align: 'center' },
  { id: 'FootbalopPlanetMainBG', label: 'تصویر پس زمینه اصلی', align: 'center' },
  { id: 'FootbalopPlanetMainBackDrop', label: 'تصویر بک دراپ', align: 'center' },
  { id: 'FootbalopPlanetImageGamePlay', label: 'تصویر گیم پلی', align: 'center' },
  { id: 'FootbalopPlanetGoal1', label: 'تصویر دربازه حریف', align: 'center' },
  { id: 'FootbalopPlanetGoal2', label: 'تصویر دربازه کاربر', align: 'center' },
  { id: 'FootbalopPlanetImageBackAsset', label: 'پس‌زمینه دستاوردها', align: 'center' },
  { id: 'FootbalopPlanetIsActive', label: 'وضعیت', align: 'center' },
  { id: 'FootbalopPlanetLevelJoinCUP', label: 'جام موردنیاز برای پیوستن', align: 'center' },
  { id: 'FootbalopPlanetLevelJoinXP', label: 'xp موردنیاز برای پیوستن', align: 'center' },
  { id: 'FootbalopPlanetJoinCostCoin', label: 'هزینه پیوستن به زمین با سکه', align: 'center' },
  { id: 'FootbalopPlanetTotalCard', label: 'تعداد کل کارت ها', align: 'center' },
  { id: 'FootbalopPlanetTotalWinHands', label: 'تعداد دست های برد', align: 'center' },
  { id: 'FootbalopPlanetXPPerHands', label: 'تعداد xp به ازای هر دست', align: 'center' },
  { id: 'FootbalopPlanetXPForWinner', label: 'xp برای برنده', align: 'center' },
  { id: 'FootbalopPlanetLevelCardGame', label: 'سطح کارت بازی', align: 'center' },
  { id: 'FootbalopPlanetWinnerCoinUP', label: 'افزایش جام برای برنده', align: 'center' },
  { id: 'FootbalopPlanetWinnerCupUP', label: 'افزایش سکه برای برنده', align: 'center' },
  { id: 'FootbalopPlanetLooserCoinAdd', label: 'افزایش سکه برای بازنده', align: 'center' },
  { id: 'FootbalopPlanetLooserCupReduce', label: 'کاهش جام برای بازنده', align: 'center' },
  { id: 'FootbalopPlanetExchangeCardsCostCoin', label: 'هزینه تبادل کارت ها', align: 'center' },
  { id: 'FootbalopPlanetOrderIndex', label: 'ترتیب نمایش', align: 'center' },
  { id: 'FootbalopPlanetCreateDate', label: 'تاریخ ایجاد', align: 'center' },
  { id: 'FootbalopPlanetPublishDate', label: 'تاریخ انتشار', align: 'center' },
  { id: '' },
];

export const GAME_PALYLIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameJoinApplicationPlayListLabel', label: 'عنوان', align: 'center', stickyCell: true },
  // { id: 'GameJoinApplicationPlayListSubTitle', label: 'عنوان فرعی', align: 'center' },
  { id: 'GameJoinApplicationPlayListLogo', label: 'لوگو (آیکون)', align: 'center' },
  { id: 'GameJoinApplicationPlayListBackDrop', label: 'پس زمینه', align: 'center' },
  // { id: 'GameJoinApplicationPlayListLastUpdate', label: 'تاریخ بروزرسانی', align: 'center' },
  // { id: 'GameJoinApplicationPlayListID', label: 'شناسه', align: 'center' },
  { id: '' },
];

export const GAME_PALYLIST_MODAL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameJoinApplicationPlayListLabel', label: 'عنوان بسته محتوا ', align: 'center' },
  { id: 'GameJoinApplicationPlayListID', label: 'شناسه بسته محتوا ', align: 'center' },
  { id: '' },
];

export const GAME_HUB_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameLogo', label: 'لوگو', align: 'center' },
  { id: 'GameName', label: 'عنوان', align: 'center', stickyCell: true },
  // { id: 'GameNameEn', label: 'عنوان انگلیسی', align: 'center' },
  // { id: 'GameCategoryLable', label: 'ژانر', align: 'center' },
  { id: 'GameModeLable', label: 'مدل بازی', align: 'center' },
  { id: 'GameTypeLable', label: 'سبک بازی', align: 'center' },
  { id: 'GameDesignModeLable', label: 'پلتفرم توسعه', align: 'center' },
  { id: 'GameOrientationLable', label: 'جهت اجرا', align: 'center' },
  // { id: 'GameID', label: 'شناسه', align: 'center' },
  // { id: 'GameSize', label: 'حجم', align: 'center' },
  // { id: 'GameTotalPlay', label: 'تعداد بازی', align: 'center' },
  // { id: 'GameAvrageRate', label: 'میانگین امتیاز', align: 'center' },
  { id: 'GameIsMobileSupport', label: 'قابلیت اجرا در موبایل', align: 'center' },
  { id: 'GameIsWebSupport', label: 'قابلیت اجرا در وب', align: 'center' },
  // { id: 'GameLastUpdate', label: 'تاریخ بروزرسانی', align: 'center' },
  { id: '' },
];

export const TAG_MANAGEMENT_MODAL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameTagTitle', label: 'لیبل', align: 'center' },
  { id: '' },
];

export const PREVIEW_MANAGEMENT_MODAL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GamePreviewTitle', label: 'عنوان', align: 'center' },
  { id: 'GamePreviewThumbnail', label: 'کاور نمایش', align: 'center' },
  // { id: 'GamePreviewTypeLable', label: 'نوع پیشنمایش', align: 'center' },
  { id: 'GamePreviewID', label: 'شناسه', align: 'center' },
  { id: '' },
];

export const GATEWAY_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GatewayLabel', label: 'عنوان', stickyCell: true },
  { id: 'GatewayActiveTypeID', label: 'وضعیت درگاه' },
  { id: 'GatewayTypeLabel', label: 'نوع درگاه' },
  { id: 'GatewayPriceTypeLabel', label: 'واحد پرداخت' },
  { id: 'GatewayCredit', label: 'اعتبار درگاه' },
  // { id: 'GatewayClientId', label: 'شناسه کاربری', align: 'center' },
  { id: 'GatewayClientToken', label: 'توکن کاربر', align: 'center' },
  { id: 'GatewayToken', label: 'توکن درگاه', align: 'center' },
  { id: '' },
];

export const GATEAWY_JOIN_PROFILE_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GatewayLabel', label: 'نام درگاه پرداخت', align: 'center', stickyCell: true },
  { id: 'GatewayProfileLabel', label: 'کاربری محصول', align: 'center' },
  { id: 'GatewayJoinGatewayProfileActiveTypeLabel', label: 'وضعیت', align: 'center' },
  { id: 'GatewayJoinGatewayProfileMinAmout', label: 'حداقل خرید', align: 'center' },
  { id: 'GatewayJoinGatewayProfileMaxAmount', label: 'حداکثر خرید', align: 'center' },
  { id: 'GatewayJoinGatewayProfileActiveDays', label: 'تعداد روزهای قعال', align: 'center' },
  { id: 'GatewayJoinGatewayProfileAccessToken', label: 'توکن', align: 'center' },
  { id: '' },
];

export const GATEWAY_PROFILE_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GatewayProfileLabel', label: 'عنوان', align: 'center', stickyCell: true },
  { id: 'GatewayProfilePackageName', label: 'عنوان بسته فروشگاه', align: 'center' },
  { id: 'GatewayProfileApplicationID', label: 'عنوان محصول', align: 'center' },
  { id: 'GatewayProfileCallback', label: 'آدرس صفحه بازگشت خرید', align: 'center' },
  { id: '' },
];

export const GATEWAY_LOG_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'projectTitle', label: 'نام محصول', align: 'center' },
  { id: 'GatewayTransactionAmount', label: 'مبلغ تراکنش', align: 'center' },
  { id: 'GatewayLogStatusTypeLabel', label: 'وضعیت', align: 'center' },
  { id: 'GatewayLogDateTime', label: 'تاریخ ثبت', align: 'center' },
];

export const GIFT_CODE_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'FootbalopGiftCodeCode', label: 'کد هدیه', align: 'center' },
  { id: 'FootbalopGiftCodeIsUsed', label: 'آیا از این کد هدیه استفاده شده؟', align: 'center' },
  { id: 'FootbalopGiftCodeFootbalopGameCardID', label: 'شناسه کارت', align: 'center' },
  { id: 'FootbalopGameCardImages', label: 'تصویر کارت', align: 'center' },
  { id: 'FootbalopGameCardName', label: 'نام بازیکن', align: 'center' },
  { id: 'FootbalopGameCardNation', label: 'ملیت', align: 'center' },
  { id: 'FootbalopGameCardTeam', label: 'تیم', align: 'center' },
  { id: 'FootbalopGameCardSeason', label: 'فصل', align: 'center' },
  { id: 'FootbalopGameCardPostion', label: 'پست', align: 'center' },
  { id: 'FootbalopGameCardAttak', label: 'حمله', align: 'center' },
  { id: 'FootbalopGameCardDefence', label: 'دفاع', align: 'center' },
  { id: 'FootbalopGameCardSpeed', label: 'سرعت', align: 'center' },
  { id: 'FootbalopGameCardOverall', label: 'امتیاز کلی', align: 'center' },
  { id: 'FootbalopGameCardPrice', label: 'قیمت', align: 'center' },
  { id: 'FootbalopGameCardStartKit', label: 'کیت شروع', align: 'center' },
  { id: 'FootbalopGameCardNumber', label: 'شماره کارت', align: 'center' },
  { id: 'FootbalopGameCardVersion', label: 'نسخه کارت', align: 'center' },
  { id: 'FootbalopGameCardID', label: 'شناسه کارت', align: 'center' },
  { id: '' },
];

export const LANDING_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'LandPageTitle', label: 'عنوان', stickyCell: true },
  { id: 'LandPageImageDesktop', label: 'تصویر دکستاپ', align: 'center' },
  { id: 'LandPageImageMobileH', label: 'تصویر موبایل (افقی)', align: 'center' },
  { id: 'LandPageImageMobileV', label: 'تصویر موبایل (عمودی)', align: 'center' },
  { id: 'LandPageCategoryLable', label: 'دسته بندی', align: 'center' },
  // { id: 'LandPageIsShowTextInfo', label: 'نمایش متن', align: 'center' },
  // { id: 'LandPageIsShowButton', label: 'نمایش دکمه', align: 'center' },
  { id: '' },
];

export const MEDIA_PLAYLIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'MediaGroupTitle', label: 'عنوان' },
  { id: 'MediaGroupTypeLable', label: 'نوع گروه بندی', align: 'center' },
  { id: 'MediaGroupID', label: 'شناسه', align: 'center' },
  { id: '' },
];

export const MEDIA_GROUP_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'MediaGroupTitle', label: 'عنوان', stickyCell: true },
  { id: 'MediaGroupTypeLable', label: 'نوع گروه بندی', align: 'center' },
  { id: 'MediaGroupID', label: 'شناسه', align: 'center' },
  { id: '' },
];

export const GIFT_CODE_INDEX_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'SubscribePackageGiftCodeCode', label: 'عنوان کد', align: 'center' },
  { id: 'SubscribePackageGiftCodeCode', label: 'کد', align: 'center' },
  { id: 'SubscribePackageGiftCodeCreatetime', label: 'تاریخ شروع', align: 'center' },
  { id: 'SubscribePackageGiftCodeExpireTime', label: 'تاریخ انقضا', align: 'center' },
  { id: 'SubscribePackageGiftCodeStatus', label: 'وضعیت', align: 'center' },
];

export const DOMAINS_INDEX_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف' },
  { id: 'ApplicationDomainHostName', label: 'عنوان', align: 'center' },
  { id: '' },
];

export const MEDIA_GROUP_ITEMS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'MediaTitle', label: 'عنوان', align: 'center', stickyCell: true },
  { id: 'MediaGroupItemOrderBy', label: 'ترتیب', align: 'center' },
  { id: 'MediaSeason', label: 'فصل', align: 'center' },
  { id: 'MediaEpisode', label: 'قسمت', align: 'center' },
  // { id: 'MediaIMDB', label: 'شناسه محتوا', align: 'center' },
  { id: 'MediaYear', label: 'سال تولید', align: 'center' },
  { id: 'MediaShortLink', label: 'لینگ دانلود محتوا', align: 'center' },
  // { id: 'MediaDateCreate', label: 'تاریخ ثبت', align: 'center' },
  // { id: 'MediaProvide', label: 'فرمت مدیا', align: 'center' },
  { id: '' },
];

export const BANNER_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'NotificationBannerTitle', label: 'عنوان بنر در پروژه', align: 'center' },
  { id: 'NotificationBannerTitlePanel', label: 'عنوان بنر در پنل', align: 'center' },
  { id: 'NotificationBannerTypeLable', label: 'نوع بنر', align: 'center' },
  { id: 'NotificationBannerDateStart', label: 'زمان شروع نمایش', align: 'center' },
  { id: 'NotificationBannerDateExpire', label: 'زمان پایان نمایش', align: 'center' },
  { id: 'NotificationBannerOrderIndex', label: 'ترتیب نمایش', align: 'center' },
  { id: 'NotificationBannerTextLink', label: 'عنوان لینک', align: 'center' },
  { id: 'NotificationBannerShowOnlyForProfile', label: 'نحوه نمایش', align: 'center' },
  { id: 'NotificationBannerStatus', label: 'وضعیت نمایش', align: 'center' },
  // { id: 'NotificationBannerDateStart', label: 'تاریخ ایجاد', align: 'center' },
  // { id: 'NotificationBannerDateExpire', label: 'تاریخ انقضا', align: 'center' },
  // { id: 'NotificationBannerTimeStart', label: 'زمان ایجاد', align: 'center' },
  // { id: 'NotificationBannerTimeEnd', label: 'زمان انقضا', align: 'center' },
  { id: '' },
];

export const PROJECT_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationID', label: 'شناسه', align: 'center' },
  { id: 'ApplicationTitle', label: 'عنوان پروژه-محصول', align: 'left', stickyCell: true },
  { id: 'ApplicationDefaultTheme', label: 'تم پیشفرض', align: 'center' },
  { id: 'ApplicationTypeTitle', label: 'مدل کسب و کار', align: 'center' },
  { id: 'ApplicationDefaultTheme', label: 'دامنه', align: 'center' },
  // { id: 'ApplicationPaymentGateway', label: 'درگاه پرداخت', align: 'center' },
  // { id: 'ApplicationGA4', label: 'کد GA', align: 'center' },
  // { id: 'ApplicationTrackerCode', label: 'کد Tracket', align: 'center' },
  // { id: 'ApplicationCreateDate', label: 'تاریخ ایجاد', align: 'center' },
  // { id: 'ApplicationAllowRegisterLogin', label: 'لاگین', align: 'center' },
  // { id: 'ApplicationEnableSocial', label: 'سوشال', align: 'center' },
  // { id: 'ApplicationShowHeader', label: 'هدر', align: 'center' },
  // { id: 'ApplicationShowFooter', label: 'فوتر', align: 'center' },
  // { id: 'ApplicationShowMenu', label: 'منو', align: 'center' },
  { id: '' },
];

export const PROJECT_LIST_MODAL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationTitle', label: 'نام محصول', align: 'left' },
  { id: '' },
];

export const COOPERATION_ID_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'AffiliatedCompanyName', label: 'نام همکاری', align: 'left' },
  { id: 'MediaGroupTitle', label: 'عنوان لیست پخش', align: 'left' },
  { id: '' },
];

export const PROJECT_FEED_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'FeedTitle', label: 'عنوان', align: 'center' },
  { id: 'FeedTypeName', label: 'نوع بسته محتوا', align: 'center' },
  { id: 'FeedOrderIndex', label: 'ترتیب نمایش', align: 'center' },
  { id: 'FeedIsActive', label: 'نمایش بسته محتوا', align: 'center' },
  // { id: 'FeedIsShowTitle', label: 'نمایش عنوان بسته محتوا', align: 'center' },
  // { id: 'FeedIsShowCaption', label: 'نمایش عنوان آیتم های بسته محتوا', align: 'center' },
  // { id: 'FeedIsMoreList', label: 'نمایش گزینه ی فهرست بسته محتوا', align: 'center' },
  { id: 'translatedOperators', label: 'محدودیت شبکه اینترنت', align: 'center' },
  // { id: 'FeedPublishDate', label: 'تاریخ انتشار', align: 'center' },
  { id: '' },
];

export const FEED_ITEMS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'FeedItemSubject', label: 'عنوان' },
  // { id: 'FeedItemSubjectSpecial', label: 'عنوان ویژه', align: 'center' },
  { id: 'FeedItemIsActive', label: 'وضعیت نمایش', align: 'center' },
  { id: 'FeedItemOrderIndex', label: 'ترتیب نمایش', align: 'center' },
  // { id: 'FeedItemTotalViewOnStart', label: 'شروع نمایش از', align: 'center' },
  // { id: 'FeedItemTotalClickOnStart', label: 'شروع کلیک از', align: 'center' },
  // { id: 'FeedItemContentDate', label: 'تاریخ تولید محتوا', align: 'center' },
  { id: 'FeedItemCreateDate', label: 'تاریخ ایجاد', align: 'center' },
  { id: 'FeedItemPublishDate', label: 'تاریخ انتشار', align: 'center' },
  { id: '' },
];

export const FEED_URL_MODAL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameName', label: 'عنوان', align: 'left' },
  { id: 'GameCategoryLable', label: 'سبک', align: 'left' },
  { id: 'GameLastUpdate', label: 'تاریخ انتشار', align: 'left' },
  { id: '' },
];

export const RTMP_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'RtmpLabel', label: 'عنوان', align: 'center', align: 'center', stickyCell: true },
  { id: 'RtmpServerLabel', label: 'نوع سرور', align: 'center' },
  { id: 'RtmpStatusLable', label: 'وضعیت سرور', align: 'center' },
  { id: 'RtmpThreads', label: 'تعداد تردها', align: 'center' },
  { id: 'RtmpRotation', label: 'قابلیت گردش', align: 'center' },
  { id: 'RtmpStartDateTime', label: 'تاریخ شروع', align: 'center' },
  { id: 'RtmpStartDateTime', label: 'ساعت شروع', align: 'center' },
  { id: '' },
];

export const RTMP_APP_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'RtmpAppLabel', label: 'عنوان', align: 'center', align: 'center', stickyCell: true },
  { id: 'RtmpAppServerLabel', label: 'نوع سرور', align: 'center' },
  { id: 'RtmpAppStartDateTime', label: 'تاریخ شروع', align: 'center' },
  { id: 'RtmpAppStartDateTime', label: 'ساعت شروع', align: 'center' },
  { id: 'RtmpAppFinishDateTime', label: 'تاریخ پایان', align: 'center' },
  { id: 'RtmpAppFinishDateTime', label: 'ساعت پایان', align: 'center' },
  { id: '' },
];

export const SOCIAL_ACCOUNT_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'شماره ردیف', align: 'center' },
  { id: 'SocialManagerAccountTypeName', label: 'نام نوع حساب', align: 'center', stickyCell: true },
  { id: 'SocialManagerAccountTypeID', label: 'شناسه نوع حساب', align: 'center' },
  { id: 'SocialManagerAccountKey', label: 'کلید حساب', align: 'center' },
  //   { id: 'token', label: 'توکن', align: 'center' },
  { id: '' },
];

export const SOCIAL_CHANNEL_LIST_TABLE_HEAD = [
  { id: 'token', label: 'شماره ردیف', align: 'center' },
  { id: 'SocialManagerChannelSocialManagerAccountID', label: 'شناسه حساب کانال', align: 'center' },
  { id: 'SocialManagerChannelName', label: 'نام کانال', align: 'center', stickyCell: true },
  { id: 'SocialManagerAccountID', label: 'شناسه حساب', align: 'center' },
  { id: 'SocialManagerAccountTypeName', label: 'نوع حساب', align: 'center' },
  // { id: 'SocialManagerAccountToken', label: 'توکن حساب', align: 'center' },
  { id: 'SocialManagerChannelKey', label: 'کلید کانال', align: 'center' },
  { id: 'SocialManagerAccountKey', label: 'کلید حساب', align: 'center' },
  { id: '' },
];

export const SOCIAL_CONTENT_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'شماره ردیف', align: 'center' },
  { id: 'SocialManagerChannelName', label: 'نام کانال', align: 'center', stickyCell: true },
  { id: 'SocialManagerContentFileName', label: 'نام فایل', align: 'center' },
  { id: 'SocialManagerContentCreatedDateTime', label: 'تاریخ ایجاد محتوا', align: 'center' },
  { id: 'SocialManagerContentStatusUpdatedDateTime', label: 'تاریخ بروزرسانی محتوا', align: 'center' },
  { id: 'SocialManagerContentFile', label: ' محتوا فایل', align: 'center' },
  { id: 'SocialManagerContentContent', label: 'متن محتوا', align: 'center' },
  { id: 'SocialManagerContentTypeName', label: 'نوع محتوا', align: 'center' },
  { id: 'SocialManagerContentStatusTypeLabel', label: 'وضعیت محتوا', align: 'center' },
  { id: 'SocialManagerAccountID', label: 'شناسه حساب', align: 'center' },
  { id: 'SocialManagerChannelID', label: 'شناسه کانال', align: 'center' },
  { id: 'SocialManagerContentID', label: 'شناسه محتوا', align: 'center' },
  { id: '' },
];

export const TRANSACTION_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'projectTitle', label: 'نام محصول', align: 'center', stickyCell: true },
  { id: 'gatewayTitle', label: 'نام درگاه', align: 'center' },
  { id: 'GatewayTransactionAmount', label: 'مبلغ تراکنش', align: 'center' },
  { id: 'transactionType', label: 'نوع تراکنش', align: 'center' },
  { id: 'transactionStatusType', label: 'وضعیت تراکنش', align: 'center' },
  { id: 'GatewayTransactionCreatedDateTime', label: 'تاریخ تراکنش', align: 'center' },
  { id: 'GatewayTransactionOrderID', label: 'کد پیگیری', align: 'center' },
  { id: 'GatewayTransactionCallback', label: 'آدرس صفحه لینک بازگشتی', align: 'center' },
];

export const TRANSACTION_PACKAGE_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'TransactionPackageLable', label: 'عنوان', stickyCell: true },
  { id: 'TransactionPackageIsActive', label: 'وضعیت', align: 'center' },
  { id: 'TransactionPackageAmountOrginal', label: 'هزینه اولیه', align: 'center' },
  { id: 'TransactionPackageDiscountPercent', label: 'درصد تخفیف', align: 'center' },
  { id: 'TransactionPackageAmountFinal', label: 'هزینه نهایی', align: 'center', tooltip: 'پس از تخفیف' },
  { id: 'TransactionPackageOrderIndex', label: 'ترتیب', align: 'center' },
  // { id: 'TransactionPackageDateStart', label: 'تاریخ شروع', align: 'center' },
  // { id: 'TransactionPackageDateEnd', label: 'تاریخ پایان', align: 'center' },
  { id: '' },
];

export const TRANSACTION_PACKAGE_ITEM_MODAL_TABLE_HEAD = [
  { id: 'rowNumber', label: 'ردیف', align: 'center' },
  { id: 'TransactionPackageItemAmountOrginal', label: 'ارزش اصلی', align: 'center' },
  { id: 'TransactionPackageItemAmountExtra', label: 'ارزش اضافی', align: 'center' },
  { id: 'TransactionPackageItemAmountFinal', label: 'ارزش نهایی', align: 'center' },
  { id: 'TransactionAmountTypeLable', label: 'نوع ارزش', align: 'center' },
  { id: '' },
];

export const REFERENCE_KEY_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'gatewayTitle', label: 'نام درگاه', align: 'center', stickyCell: true },
  { id: 'gatewayStatus', label: 'وضعیت درگاه', align: 'center' },
  { id: 'gatewayPriceType', label: 'واحد پرداخت', align: 'center' },
  { id: 'GatewayToken', label: 'توکن درگاه', align: 'center' },
  { id: 'GatewayRefrenceKeyKey', label: 'توکن نشست', align: 'center' },
];

export const UPLOAD_TO_SERVERT_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'UploadToServerTitle', label: 'عنوان محتوا', stickyCell: true },
  // { id: 'UploadToServerTypeLable', label: 'نوع محتوا', align: 'center' },
  { id: 'UploadToServerDateCreate', label: 'تاریخ آپلود', align: 'center' },
  { id: 'UploadToServerStatusLable', label: 'وضعیت', align: 'center' },
  { id: 'UploadToServerDescription', label: 'توضیحات', align: 'center' },
  { id: 'UploadToServerPathHTTP', label: 'لینک محتوا', align: 'center' },
  { id: '' },
];

export const UPLOAD_TO_SERVERT_LIST_MODAL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'UploadToServerTitle', label: 'عنوان محتوا', align: 'center' },
  { id: 'UploadToServerTypeLable', label: 'نوع محتوا', align: 'center' },
  // { id: 'UploadToServerStatusLable', label: 'وضعیت', align: 'center' },
  { id: 'UploadToServerID', label: 'شناسه', align: 'center' },
  // { id: 'UploadToServerDateCreate', label: 'تاریخ آپلود', align: 'center' },
  { id: '' },
];

export const USER_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ProfileAvatarDefault', label: 'پروفایل', align: 'center' },
  { id: 'ProfileName', label: 'نام', align: 'center', stickyCell: true },
  { id: 'ProfileLastName', label: 'نام خانوادگی', align: 'center' },
  { id: 'ProfileID', label: 'شناسه کاربر', align: 'center' },
  { id: 'ProfileMobile', label: 'موبایل', align: 'center' },
  { id: 'ProfileEmail', label: 'ایمیل', align: 'center' },
  { id: '' },
];

export const WHEEL_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'WheelLabel', label: 'عنوان', align: 'left', stickyCell: true },
  // { id: 'WheelID', label: 'شناسه', align: 'center' },
  { id: 'WheelEnable', label: 'وضعیت', align: 'center' },
  { id: 'WheelTypeLabel', label: 'نوع گردونه', align: 'center' },
  { id: 'WheelWaitingHours', label: 'مدت زمان انتظار', align: 'center' },
  { id: 'WheelRotateTimes', label: 'تعداد گردش', align: 'center', tooltip: 'تعداد گردش گردونه بر دور خود' },
  // { id: 'WheelTransactionAmountTypeID', label: 'نوع هزینه', align: 'center' },
  // { id: 'WheelCost', label: 'هزینه گرداندن', align: 'center' },
  { id: 'WheelFreeChance', label: 'تعداد دفعات قابل گردش رایگان', align: 'center' },
  { id: '' },
];

export const WHEEL_ITEM_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'WheelItemLabel', label: 'عنوان', align: 'left' },
  { id: 'WheelItemImage', label: 'تصویر', align: 'center' },
  { id: 'WheelItemPopupImage', label: 'تصویر اعلان', align: 'center' },
  // { id: 'WheelItemID', label: 'کد یکتا', align: 'center' },
  { id: 'WheelItemTypeLabel', label: 'ارزش خانه', align: 'center' },
  { id: 'WheelItemQuantity', label: 'خانه', align: 'center' },
  { id: 'WheelItemProbability', label: 'وزن (درصد)', align: 'center' },
  { id: 'WheelItemOrder', label: 'ترتیب نمایش', align: 'center', tooltip: 'بر اساس جهت چرخش عقربه ساعت' },
  { id: 'WheelItemTransactionAmountTypeID', label: 'نوع پاداش', align: 'center' },
  { id: 'rewWheelItemRewardard', label: 'تعداد پاداش', align: 'center' },
  { id: '' },
];

export const WIKI_MEDIA_INFO_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'MediaWikiID', label: 'کد ثبت', align: 'center' },
  { id: 'MediaWikiTitle', label: 'عنوان', align: 'center' },
  { id: 'MediaWikiLang', label: 'زبان', align: 'center' },
  { id: 'MediaWikiTypeLable', label: 'نوع دانشنامه', align: 'center' },
  { id: 'MediaWikiIsShort', label: 'کوتاه بودن متن دانشنامه', align: 'center' },
  { id: '' },
];

// ADMIN WORKSPACE ------------------------------------------------------------

export const COMMENTS_STATUS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationTitle', label: 'نام محصول', align: 'center' },
  { id: 'tblCommentStatus_Lable', label: 'وضعیت', align: 'center' },
  { id: 'TotalItems', label: 'تعداد', align: 'center' },
];

export const COMMENTS_REPORT_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'TotalItems', label: 'تعداد', align: 'center' },
  { id: 'tblCommentStatus_Lable', label: 'وضعیت', align: 'center' },
];

export const CONTENT_HUB_STATUS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'StatusLable', label: 'وضعیت', align: 'center' },
  { id: 'TotalItems', label: 'تعداد', align: 'center' },
];

export const DUEL_STATUS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationTitle', label: 'نام محصول', align: 'center', stickyCell: true },
  { id: 'DuelTitle', label: 'نام تورنومنت', align: 'center' },
  { id: 'TotalItems', label: 'تعداد', align: 'center' },
];

export const DUEL_DAILY_REPORT_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'DuelTitle', label: 'نام تورنومنت', align: 'center' },
  { id: 'TotalItems', label: 'تعداد', align: 'center' },
];

export const FEEDS_STATUS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationTitle', label: 'نام محصول', align: 'center' },
  { id: 'TotalItems', label: 'تعداد بازدید', align: 'center' },
  { id: 'TotalView', label: 'زمان بازدید', align: 'center' },
  { id: '', label: 'میانگین بازدید', align: 'center' },
];

export const GAME_HUB_STATUS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameDesignMode', label: 'عنوان', align: 'center' },
  { id: 'TotalItems', label: 'تعداد', align: 'center' },
];

export const LIKES_STATUS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationTitle', label: 'نام محصول', align: 'center' },
  { id: 'TotalItems', label: 'تعداد لایک ها', align: 'center' },
];

export const USERS_STATUS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationTitle', label: 'نام محصول', align: 'center' },
  { id: 'TotalItems', label: 'تعداد', align: 'center' },
];

export const FINANCIAL_STATUS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ApplicationTitle', label: 'نام محصول', align: 'center', stickyCell: true },
  { id: 'TranscationType', label: 'عملیات', align: 'center' },
  { id: 'AmountType', label: 'واحد', align: 'center' },
  { id: 'SumAmount', label: 'مقدار', align: 'center' },
  { id: 'TotalItems', label: 'تعداد', align: 'center' },
];

export const FINANCIAL_REPORT_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'TranscationType', label: 'عملیات', align: 'center' },
  { id: 'AmountType', label: 'واحد', align: 'center' },
  { id: 'SumAmount', label: 'مقدار', align: 'center' },
  { id: 'TotalItems', label: 'تعداد', align: 'center' },
];

// SOCIAL MANAGERS ------------------------------------------------------------

export const ACCOUNT_SELECTION_TABLE_HEAD = [
  { id: 'RowNum', label: 'شماره ردیف', align: 'center' },
  { id: 'SocialManagerAccountTypeName', label: 'نام نوع حساب', align: 'center' },
  { id: 'SocialManagerAccountTypeID', label: 'شناسه نوع حساب', align: 'center' },
  //   { id: 'token', label: 'توکن', align: 'center' },
  { id: '' },
];

export const CHANNEL_SELECTION_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'SocialManagerChannelID', label: 'شناسه', align: 'center' },
  { id: 'SocialManagerChannelName', label: 'نام کانال', align: 'center' },
  { id: '' },
];

export const CONTENT_SELECTION_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameName', label: 'عنوان', align: 'left' },
  { id: 'GameModeLable', label: 'سبک', align: 'left' },
  { id: 'GameCategoryLable', label: 'ژانر', align: 'left' },
  { id: 'GameLastUpdate', label: 'تاریخ انتشار', align: 'left' },
  { id: '' },
];

// CONTENT_HUB -----------------------------------------

// todo ! CONTENT_ARTIST_TABLE_HEAD is not edited
export const CONTENT_ARTIST_TABLE_HEAD = [
  { id: 'rowNumber', label: 'ردیف', align: 'center' },
  { id: 'reference', label: 'نام هنرمند', align: 'center' },
  { id: '' },
];

export const CONTENT_MEDIA_SCORE_TABLE_HEAD = [
  { id: 'rowNumber', label: 'ردیف', align: 'center' },
  { id: 'MediaScoreTypeLable', label: 'مرجع', align: 'center' },
  { id: 'MediaScoreValue', label: 'امتیاز', align: 'center' },
  { id: '' },
];

export const CONTENT_IMAGE_TABLE_HEAD = [
  { id: 'rowNumber', label: 'ردیف', align: 'center' },
  { id: 'MediaThumbnailTypeName', label: 'نوع تصویر', align: 'center' },
  { id: 'MediaThumbnailFileName', label: 'عنوان تصویر', align: 'center' },
  { id: 'MediaThumbnailSizeW', label: 'طول', align: 'center' },
  { id: 'MediaThumbnailSizeH', label: 'عرض', align: 'center' },
  { id: 'MediaThumbnailSize', label: 'حجم', align: 'center' },
  { id: 'MediaThumbnailFileExtention', label: 'فرمت تصویر', align: 'center' },
  // { id: 'MediaThumbnailID', label: 'کد ثبت', align: 'center' },
  { id: '' },
];

export const CONTENT_MEDIA_GROUP_TO_ARTIST_TABLE_HEAD = [
  { id: 'rowNumber', label: 'ردیف', align: 'center' },
  { id: 'ArtistsImages', label: 'تصویر', align: 'center' },
  { id: 'ArtistsLable', label: 'عنوان', align: 'center' },
  { id: '' },
];

export const CONTENT_STREAMING_SERVICE_TABLE_HEAD = [
  { id: 'rowNumber', label: 'ردیف', align: 'center' },
  { id: 'MediaProvideID', label: 'کد ثبت', align: 'center' },
  { id: 'MediaProvideTypeLable', label: 'نوع محتوا', align: 'center' },
  { id: 'MediaLanguageLable', label: 'زبان', align: 'center' },
  { id: '' },
];

export const CONTENT_SUBTITLE_TABLE_HEAD = [
  { id: 'rowNumber', label: 'ردیف', align: 'center' },
  { id: 'MediaSubtitleLable', label: 'عنوان زیرنویس', align: 'center' },
  { id: 'MediaSubtitleID', label: 'کد ثبت', align: 'center' },
  { id: 'MediaSubtitleFileName', label: 'نام فایل', align: 'center' },
  { id: '' },
];

export const METADATA_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'UploadToServerTitle', label: 'عنوان محتوا', align: 'center' },
  { id: 'UploadToServerTypeLable', label: 'نوع محتوا', align: 'center' },
  { id: 'UploadToServerStatusLable', label: 'وضعیت', align: 'center' },
  { id: 'UploadToServerID', label: 'شناسه', align: 'center' },
  { id: 'UploadToServerDateCreate', label: 'تاریخ آپلود', align: 'center' },
  { id: '' },
];

export const GAME_ENTRY_FEE_REWARD_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  // { id: 'GameName', label: 'نام بازی', align: 'left', stickyCell: true },
  { id: 'GameEntryFeeRewardsAmount', label: 'حداقل امتیاز', align: 'center' },
  { id: 'GameEntryFeeRewardsTransactionAmountTypeID', label: 'واحد پاداش', align: 'center' },
  { id: 'GameEntryFeeRewardsScore', label: 'تعداد پاداش', align: 'center' },
  { id: '' },
];

// APP VERSION CONTROL ------------------------------------------------------------

export const APP_VERSION_CONTROL_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'AppVersionControlLable', label: 'عنوان', align: 'center' },
  { id: 'AppVersionControlIsForceUpdate', label: 'نیاز به آپدیت ضروی', align: 'center' },
  { id: 'AppVersionControlPackageName', label: 'نام بسته', align: 'center' },
  { id: 'AppVersionControlVersionApp', label: 'ورژن محصول', align: 'center' },
  { id: 'AppVersionControlUrlDownloadApp', label: 'لینک دانلود اپ', align: 'center' },
  // { id: 'video_version', label: 'ورژن ویدیو', align: 'center' },
  { id: '' },
];

export const AVATAR_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  // { id: 'AvatarTitle', label: 'عنوان', align: 'center' },
  { id: 'AvatarURLPreview', label: 'پیشنمایش آواتار', align: 'center' },
  { id: 'AvatarURLOriginal', label: 'تصویر آواتار', align: 'center' },
  { id: 'AvatarEnable', label: 'وضعیت نمایش', align: 'center' },
  // { id: 'AvatarTransactionAmountTypeID', label: 'واحد پرداخت', align: 'center' },
  { id: 'AvatarAmountOriginal', label: 'هزینه اولیه', align: 'center' },
  { id: 'AvatarDiscountPercent', label: 'درصد تخفیف', align: 'center' },
  { id: 'AvatarAmountFinal', label: 'هزینه نهایی', align: 'center' },
  { id: '' },
];

// ------------------------------------------------------------------------------------

export const SERVICE_GAME_REPORT_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'date', label: 'تاریخ', align: 'center' },
  { id: '1', label: 'میانگین تعداد کاربر روزانه', align: 'left' },
  { id: '2', label: 'میانگین تعداد بازیگن هفتگی', align: 'center' },
  { id: '3', label: 'میانگین تعداد بازیکن جدید هفتگی', align: 'center' },
  { id: '4', label: 'تعداد بازی جدید', align: 'center' },
  { id: '5', label: 'میانگین زمان صرف شده کاربران در بازی (دقیقه)', align: 'center' },
  { id: '6', label: 'تعداد پرداخت', align: 'center' },
  { id: '7', label: 'مقدار پرداخت (تومان)', align: 'center' },
  { id: '8', label: 'حجم ترافیک مصرفی بازی (گیگابایت)', align: 'center' },
  { id: '9', label: 'حجم ترافیک مصرفی استریم بازی (گیگابایت)', align: 'center' },
  { id: '10', label: 'ترافیک کل (گیگابایت)', align: 'center' },
  { id: '11', label: 'درآمد کسب شده از ترافیک (تومان)', align: 'center' },
  { id: '12', label: 'کل درآمد از سرویس گیم (تومان)', align: 'center' },
  { id: '' },
];

// ------------------------------------------------------------------------------------

export const COMMENT_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'AVATAR', label: 'پروفایل کاربر', align: 'center' },
  { id: 'ProfileName', label: 'نام و نام خانوادگی کاربر', align: 'left' },
  { id: 'CommentCreateDate', label: 'تاریخ', align: 'center' },
  { id: 'CommentCommentStatusID', label: 'وضعیت نظر', align: 'center' },
  { id: 'ContentType', label: 'نوع محتوا', align: 'left' },
  { id: 'ContentTitle', label: 'تایتل محتوا', align: 'left' },
  { id: 'CommentBody', label: 'متن نظر', align: 'left' },
  { id: '' },
];

// ------------------------------------------------------------------------------------

export const MEDIA_SOCIAL_PLAYER_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'MediaSocialPlayerTitle', label: 'عنوان' },
  { id: 'MediaSocialPlayerImageCover', label: 'تصویر کاور', align: 'center' },
  { id: 'MediaSocialPlayerImageThumbnail', label: 'تصویر پس زمینه', align: 'center' },
  // { id: 'MediaSocialPlayerHLS', label: 'لینک پخش HLS', align: 'center' },
  { id: 'MediaSocialPlayerOrderIndex', label: 'ترتیب نمایش', align: 'center' },
  // { id: 'MediaSocialPlayerDateTimeStart', label: 'تاریخ شروع', align: 'center' },
  // { id: 'MediaSocialPlayerDateTimeEnd', label: 'تاریخ پایان', align: 'center' },
  { id: 'MediaSocialPlayerClickUrl', label: 'لینک کلیک', align: 'center' },
  { id: 'MediaSocialPlayerVastUrl', label: 'لینک تبلیغات ویدیویی (VAST)', align: 'center' },
  { id: '' },
];

// ------------------------------------------------------------------------------------

export const SUBSCRIBE_PACKAGE_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'SubscribePackageTitle', label: 'عنوان' },
  { id: 'SubscribePackageSubscribePackageTypeID', label: 'نوع بسته' },
  { id: 'SubscribePackageDaysCount', label: 'تعداد روزهای اشتراک' },
  // { id: 'SubscribePackageOrderBy', label: 'ترتیب نمایش' },
  // { id: 'SubscribePackageIsSpecial', label: 'آیا پکیج ویژه است؟' },
  { id: 'SubscribePackageAmountDefault', label: 'هزینه', align: 'center' },
  { id: 'SubscribePackageAmountDiscount', label: 'درصد تخفیف' },
  { id: 'SubscribePackageAmountFinal', label: 'هزنیه نهایی اشتراک' },
  { id: 'SubscribePackageTransactionAmountTypeID', label: 'نوع واحد پرداخت' },
  { id: 'SubscribePackageSubscribePackagePositionID', label: 'جایگاه نمایشی بسته' },
  { id: 'SubscribePackageUserLevel', label: 'سطح کاربر', align: 'center' },
  { id: 'SubscribePackageClubPoint', label: 'امتیاز باشگاه', align: 'center' },
  { id: 'SubscribePackageIsEnable', label: 'وضعیت نمایش' },
  { id: '' },
];

export const SUBSCRIBE_PACKAGE_TYPE_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'SubscribePackageTypeLable', label: 'عنوان', align: 'center' },
  { id: '' },
];

export const SUBSCRIBE_PACKAGE_POSITION_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'SubscribePackagePositionLable', label: 'عنوان', align: 'center' },
  { id: '' },
];

export const TRANSACTION_AMOUNT_TYPE_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'TransactionAmountTypeLable', label: 'عنوان', align: 'center' },
  { id: 'TransactionAmountTypeLogo', label: 'لوگو', align: 'center' },
  { id: 'TransactionAmountTypeHelp', label: 'متن راهنما', align: 'center' },
  { id: '' },
];

export const NOTIFICATION_STYLE_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'NotificationStyleImageUrl', label: 'تصویر', align: 'center' },
  { id: 'NotificationStyleLable', label: 'عنوان', align: 'center' },
  { id: 'NotificationStyleType', label: 'نوع فریم', align: 'center' },
  { id: '' },
];

export const NOTIFICATION_POPUP_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'NotificationPopupTitle', label: 'عنوان در پروژه', align: 'center' },
  { id: 'NotificationPopupTitlePanel', label: 'عنوان در پنل', align: 'center' },
  { id: 'NotificationPopupNumberPerDay', label: 'تعداد نمایش در روز', align: 'center' },
  { id: 'NotificationPopupStartDate', label: 'زمان شروع نمایش', align: 'center' },
  { id: 'NotificationPopupEndDate', label: 'زمان پایان نمایش', align: 'center' },
  { id: 'NotificationPopupStatus', label: 'وضعیت نمایش', align: 'center' },
  { id: '' },
];

// ------------------------------------------------------------------------------------

export const SUB_MENU_ITEMS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameName', label: 'عنوان', align: 'center' },
  { id: 'GameJoinApplicationHasLeaderBoard', label: 'لوگو', align: 'center' },
  { id: 'GameJoinApplicationHasLeaderBoard', label: 'تم', align: 'center' },
  { id: 'GameJoinApplicationHasLeaderBoard', label: 'ترتیب', align: 'center' },
  { id: 'GameJoinApplicationHasLeaderBoard', label: 'لینک', align: 'center' },
  { id: 'GameJoinApplicationHasLeaderBoard', label: 'نمایش زیرگروه', align: 'center' },
  { id: '' },
];

// ------------------------------------------------------------------------------------

export const EXTRA_CONTENT_DETAILS_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'TagTagTypeID', label: 'نوع تگ', align: 'center' },
  { id: 'TagName', label: 'مقدار تگ', align: 'center' },
  { id: '' },
];

// ------------------------------------------------------------------------------------

// GAEM HUB

export const GAME_PREVIEW_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GamePreviewUrlImage', label: 'کاور نمایش', align: 'center' },
  { id: 'GamePreviewTitle', label: 'عنوان', align: 'center' },
  { id: 'GamePreviewLabel', label: 'نوع پیشنمایش', align: 'center' },
  { id: '' },
];

export const GAME_HASHTAG_TABLE_HEAD = [
  { id: 'rowNumber', label: 'ردیف', align: 'center' },
  { id: 'GameHashTagTitle', label: 'هشتگ', align: 'center' },
  { id: '' },
];

export const GAME_WIKI_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameWikiTitle', label: 'عنوان', align: 'center' },
  { id: 'GameWikiLang', label: 'زبان', align: 'center' },
  { id: 'GameWikiTypeLable', label: 'نوع دانشنامه', align: 'center' },
  { id: 'GameWikiIsShort', label: 'کوتاه بودن متن دانشنامه', align: 'center' },
  { id: '' },
];

export const GAME_TAG_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'TagTagTypeID', label: 'نوع تگ', align: 'center' },
  { id: 'TagName', label: 'مقدار تگ', align: 'center' },
  { id: '' },
];

export const GAME_ARTIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'ArtistsImages', label: 'تصویر', align: 'center' },
  { id: 'tblGameJoinArtist_RoleTitle', label: 'نقش سازنده/عوامل', align: 'center' },
  { id: 'ArtistsLable', label: 'نام سازنده/عوامل', align: 'center' },
  { id: '' },
];

export const MEDIA_REWARDS_LIST_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'TransactionAmountTypeLable', label: 'نوع پاداش', align: 'center' },
  { id: 'MediaRewardsTimeCount', label: 'زمان دیدن ویدیو(ثانیه)', align: 'center' },
  { id: 'MeidaRewardsValue', label: 'مقدار پاداش', align: 'center' },
  { id: 'MediaRewardsScore', label: 'امتیاز پاداش', align: 'center' },
  { id: 'MediaRewardsClubPoint', label: 'امتیاز باشگاه', align: 'center' },
  { id: 'MediaRewardsUserLevel', label: 'سطح کاربر ', align: 'center' },
  { id: '' },
];

export const DUEL_GIFT_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  // { id: 'DuelImageBanner', label: 'بنر' },
  { id: 'DuelGiftGiftTitle', label: 'عنوان', align: 'center' },
  { id: 'DuelGiftCreateDate', label: 'تاریخ ثبت', align: 'center' },
  { id: 'DuelGiftStartNumber', label: 'از رتبه', align: 'center' },
  { id: 'DuelGiftEndNumbe', label: 'تا رتبه', align: 'center' },

  { id: '' },
  // { id: 'score', label: 'امتیاز', align: 'center' },
];

export const GAME_HUB_SIMILAR_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameLogo', label: 'لوگو', align: 'right' },
  { id: 'GameName', label: 'عنوان', align: 'center', stickyCell: true },
  { id: 'GameModeLable', label: 'مدل بازی', align: 'center' },
  { id: 'GameTypeLable', label: 'سبک بازی', align: 'center' },
  { id: '' },
];

export const GAME_HUB_SIMILAR_ADDED_TABLE_HEAD = [
  { id: 'RowNum', label: 'ردیف', align: 'center' },
  { id: 'GameLogo', label: 'لوگو', align: 'center' },
  { id: 'GameName', label: 'عنوان', align: 'center', stickyCell: true },
  { id: '' },
];
